import type { DateRangePresetKey } from "@/lib/dateRangePresets";

export interface FilterConfig {
  key: string;
  label: string;
  type: "select" | "daterange" | "range";
  allLabel?: string;
  min?: number;
  max?: number;
  /** When true, render a `select` filter as an inline checklist (multi-select). */
  multi?: boolean;
  /** When true, render a search box above the checklist. */
  searchable?: boolean;
}

export interface FilterOption {
  value: string;
  label: string;
}

export type DateRangeValue = { from: string; to: string; preset?: DateRangePresetKey };
export type RangeValue = { min: number; max: number };
export type SelectValue = string[];

export type FilterValue = SelectValue | DateRangeValue | RangeValue;

/**
 * Per-filter negation flag. `true` == negative (NOT IN / !=), mirroring the
 * legacy `filterPlus` semantics from `html/html/lib/filters/save-filters.php`.
 */
export type FilterNegations = Record<string, boolean>;

export function isDateRange(v: FilterValue): v is DateRangeValue {
  return typeof v === "object" && !Array.isArray(v) && "from" in v;
}

export function isRange(v: FilterValue): v is RangeValue {
  return typeof v === "object" && !Array.isArray(v) && "min" in v;
}

export function isSelect(v: FilterValue): v is SelectValue {
  return Array.isArray(v);
}

export function filterActiveCount(v: FilterValue | undefined): number {
  if (!v) return 0;
  if (isDateRange(v)) return v.from || v.to ? 1 : 0;
  if (isRange(v)) return v.min > 0 || v.max < 120 ? 1 : 0;
  return v.length;
}
